import React from "react";

export const TVIcon = ({ width, height, extraClasses = "" }) => {
  return (
    <span role="img" className={extraClasses}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width || "100%"}
        height={height || "100%"}
        viewBox="0 0 11 10"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.10002 9.14999V6.84999H0.150024V0.149994H10.85V6.84999H5.90002V9.14999H7.85002V9.84999H3.15002V9.14999H5.10002ZM10.05 0.949994H0.950025V6.04999H10.05V0.949994Z"
          fill="#212121"
        />
      </svg>
    </span>
  );
};
